import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as CompanyContextConsumer } from '../../../contexts/CompanyContext';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import { IMAGE_CDN_URL } from '../../../utilities/imageCDN';
import Rating from '../../JobV3/Elements/Rating/Rating';
import CallToActionButtons from './CallToActionButtons/CallToActionButtons';
import CompanyBannerImage from './CompanyBannerImage/CompanyBannerImage';
import './CompanyHeaderV2.scss';
import CompanyIcon from './CompanyIcon/CompanyIcon';
import {
    subnavMenuItems,
    subnavMobileMenuItems,
} from './Subnav/subnavMenuItems';
import SectionTabHeader from '../../Elements/SectionTabHeader/SectionTabHeader';

const BASE_URL = IMAGE_CDN_URL;

export default class CompanyHeaderV2 extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         *  is sticky layout (scrolled down) or regular header layout
         */
        isSticky: PropTypes.bool,
    };

    static defaultProps = {
        isSticky: false,
    };

    renderHqAndSize = ({ hq, companySize }) => {
        const cityState = hq
            ? `${hq.city ? hq.city + ',' : ''} ${hq.state || ''}`
            : '';
        const country = hq && hq.country ? `(${hq.country})` : '';
        const hqHasText = !!(cityState + country).trim();
        return (
            <div className="hq-and-size italic pb-1">
                {hqHasText && (
                    <React.Fragment>
                        <span className="mr-1">Headquarters:</span>
                        <span className="bold mr-1">{cityState}</span>
                        {country}
                    </React.Fragment>
                )}
                {hqHasText && !!companySize && (
                    <i className="mx-1 mx-md-2 no-italic">&#9474;</i>
                )}
                {companySize && <span>{companySize}&nbsp;Employees</span>}
            </div>
        );
    };

    renderHeaderContent = ({
        company,
        followCompany,
        unfollowCompany,
        userId,
    }) => {
        const callToAction = this.renderCTAButtons(
            company,
            unfollowCompany,
            followCompany,
            userId
        );
        const remoteUrl = this.parseUrl(company.remoteUrl);
        return (
            <header className="header-info">
                <div className="title-row">
                    <div
                        className="company-logo"
                        onClick={this.props.isSticky ? this.scrollToTop : null}
                    >
                        <CompanyIcon
                            logo={this.getLogoObject(company)}
                            classes={this.props.isSticky ? 'mini' : ''}
                        />
                    </div>
                    <div className="company-details">
                        <h1
                            className="company-name oswald-light"
                            title={company.companyName}
                            onClick={this.scrollToTop}
                        >
                            {company.companyName}
                        </h1>
                        <div className="divider">
                            <div />
                        </div>
                        {company.remoteUrl && (
                            <div className="external-url bold italic pt-2">
                                <a href={`//${remoteUrl}`} target="_blank">
                                    https://{remoteUrl}
                                </a>
                            </div>
                        )}
                        {company.employerInfo &&
                            company.isSponsor &&
                            this.renderHqAndSize(company.employerInfo)}
                    </div>
                    <div className="ratings oswald-light">
                        <Rating rating={company.rating} />
                        &nbsp;
                    </div>
                    <div className="button-group button-col">
                        {callToAction}
                    </div>
                </div>
                <div className="button-group button-row sticky-hide">
                    {callToAction}
                </div>
            </header>
        );
    };

    parseUrl = (url) => (url && url.match('//') ? url.split('//')[1] : url);
    renderVerfiedFlag = () => {
        const flagSrc =
            BASE_URL + '/v1544126185/verified_flag_er1jai_bevsl4.png';
        return <img className="verified-flag sticky-hide" src={flagSrc} />;
    };

    renderCTAButtons = (
        { companyUrl, companyId, isFollowed, companyName, logo },
        unfollowCompany,
        followCompany,
        userId
    ) => {
        const ctaProps = {
            companyUrl,
            companyId,
            isFollowed,
            unfollowCompany,
            followCompany,
            userId,
            companyName,
            logo,
        };
        return <CallToActionButtons {...ctaProps} />;
    };

    getSubnavProps = (company) => {
        const isSponsorKey = company.isSponsor ? 'sponsor' : 'nonSponsor';
        const jobCount =
            company.employerInfo && company.isSponsor
                ? company.employerInfo.jobCount
                : null;
        const reviewCount = company.reviewCount;
        const desktopMenuItems = subnavMenuItems(
            isSponsorKey,
            company.companyUrl,
            jobCount,
            reviewCount
        );
        const mobileMenuItems = subnavMobileMenuItems(
            isSponsorKey,
            company.companyUrl,
            jobCount,
            reviewCount
        );
        return {
            desktopMenuItems,
            mobileMenuItems,
        };
    };

    getLogoObject = ({ logo, isSponsor }) => {
        const logoObject =
            isSponsor && logo && logo.src
                ? { src: BASE_URL + logo.src, alt: logo.alt }
                : null;
        return logoObject;
    };

    renderSeo = (googleSeo) => {
        if (googleSeo) {
            const content = {};
            content.__html = `<script type="application/ld+json">${googleSeo}</script>`;
            return (
                <div className="google-seo" dangerouslySetInnerHTML={content} />
            );
        }
    };

    scrollToTop = () => window.scroll({ top: 0, behavior: 'smooth' });

    componentDidMount() {
        this.props.context && this.props.context.setGlobalNavSticky
            ? this.props.context.setGlobalNavSticky(false)
            : null;
    }

    render() {
        const isSticky = this.props.isSticky;
        return (
            <div
                className={`component-Layout-CompanyHeaderV2 ${
                    isSticky ? 'sticky-layout' : ''
                }`}
            >
                <CompanyContextConsumer>
                    {(context) => {
                        const company = context.company;
                        const employer = company.employerInfo;
                        const { banner } = employer || {};
                        return (
                            <React.Fragment>
                                <div
                                    className={`header-container p-0 ${
                                        company.isSponsor
                                            ? 'is-sponsor'
                                            : 'non-sponsor'
                                    }`}
                                >
                                    {company.isSponsor &&
                                        this.renderVerfiedFlag()}
                                    {company.isSponsor &&
                                    banner &&
                                    banner.src ? (
                                        <CompanyBannerImage
                                            img={banner}
                                            isSponsor={company.isSponsor}
                                        />
                                    ) : (
                                        <div className="banner-placeholder" />
                                    )}
                                    {company &&
                                        this.renderHeaderContent(context)}
                                </div>
                                <div
                                    className={`shadow ${
                                        isSticky ? 'd-none' : ''
                                    }`}
                                />
                                <PageConsumer>
                                    {({ pageProps }) => (
                                        <SectionTabHeader
                                            {...this.getSubnavProps(company)}
                                            pagePath={
                                                pageProps.url &&
                                                pageProps.url.path
                                            }
                                            shouldSubNavOpenNewTabs={
                                                this.props
                                                    .shouldSubNavOpenNewTabs
                                            }
                                        />
                                    )}
                                </PageConsumer>
                                {this.renderSeo(company.googleSeo)}
                            </React.Fragment>
                        );
                    }}
                </CompanyContextConsumer>
            </div>
        );
    }
}
